import React, { FunctionComponent } from 'react';
import { LinkProps } from 'components/link/link';
import { P2, TextColor } from 'components/typography';
import Localization from 'lib/localization';

export type FooterLinksItemProps = LinkProps & {
    text: string;
    url?: string;
    extraClasses?: string;
};

function setFooterItems(items: FooterLinksItemProps[]) {
    return items
        .filter((item) => item.text)
        .map((originalItem: FooterLinksItemProps) => {
            // prevent mutation of original footer links item
            const item = { ...originalItem };

            if (item.url?.includes('contact-us')) {
                item.url = item.url?.replace('contact-us', 'bff/contact-us');
            }

            if (item.url?.includes('guidelines')) {
                item.url = item.url?.replace('guidelines', 'bff/guidelines');
            }

            if (item.url?.includes('terms')) {
                item.url = item.url?.replace('terms', 'bff/terms');
            }

            if (item.url?.includes('privacy')) {
                item.url = item.url?.replace('privacy', 'bff/privacy');
            }

            if (item.url?.includes('help')) {
                item.url = item.url?.replace('help', 'bff/help');
            }

            if (item.url?.includes('date/seasonal')) {
                item.url = item.url?.replace('date/seasonal', 'bff/friendship');
                item.text = Localization.get(
                    'bumblesite@bff.landing.section.five.column.right.title'
                );
            }

            return item;
        });
}

export type FooterLinksProps = {
    items: FooterLinksItemProps[];
};

const FooterLinks: FunctionComponent<FooterLinksProps> = (props) => {
    const { items } = props;

    return (
        <div className="footer-links">
            {setFooterItems(items).map((item: FooterLinksItemProps, key) => (
                <div className="footer-links__item" key={`footer-links-item-${key}`}>
                    <P2 color={TextColor.BLACK}>
                        <a
                            className={`footer-links__link ${item.extraClasses || ''}`}
                            href={item.url}
                            target={item.target}
                        >
                            {item.text}
                        </a>
                    </P2>
                </div>
            ))}
        </div>
    );
};

export default FooterLinks;
